import React from 'react'
import { graphql } from 'gatsby'
import Header from '../components/Header'
import Footer from '../components/Footer'
import PageHelmet from 'src/components/PageHelmet'
import ContactsPage from 'src/components/ContactsPage'

const Contacts = (props) => {
  const {
    data: {
      allMarkdownRemark: {
        edges: [node],
      },
    },
    pageContext: { locale },
  } = props
  return (
    <>
      <PageHelmet title="Contacts" locale={locale} />
      <Header full={true} locale={locale} />
      <ContactsPage data={node} locale={locale} />
      <Footer locale={locale} />
    </>
  )
}

export const query = graphql`
  query {
    allMarkdownRemark(filter: { frontmatter: { templateKey: { eq: "Contacts" } } }) {
      edges {
        node {
          html
          frontmatter {
            title
          }
        }
      }
    }
  }
`

export default Contacts
